var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resourceParent)?_c('gl-link',{attrs:{"href":_vm.resourceParent.web_url}},[_vm._v(_vm._s(_vm.resourceParent.full_name))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }